'use client';

import Link from 'next/link';
import type { FC } from 'react';
import { usePathname } from 'next/navigation';

const ProductNotFound: FC = () => {
  const pathname = usePathname();

  const splitted = pathname.split('/');

  return (
    <main className="error-page">
      <div className="container">
        <div className="error-wrapper">
          <h2>Product : '{splitted[splitted.length - 1]}' Not Found</h2>
          <p>This page could not be found</p>

          <p>
            <Link href="/store">
              <button className="colored">All Products</button>
            </Link>
          </p>
        </div>
      </div>
    </main>
  );
};

export default ProductNotFound;
